export const INPUT_FILE_NUMBER = 'input-file-number';
export const NOTIFICATION_BOX = 'notification-box';
export const NOTIFICATION_BOX_TITLE = 'notification-box-title';
export const NOTIFICATION_BOX_CONTENT = 'notification-box-content';
export const PAGE_HEADER = 'page-header';

export const APP_LINK = 'app-link';

export const STATUS_ICON = 'status-icon';

export const MENU_ITEM_SIGNOUT = 'menu-item-signout';
export const MENU_ITEM_LANGUAGE_CHANGE = 'menu-item-language-change';
export const MOBILE_MENU_BUTTON = 'mobile-menu__button';
export const MAIN_NAVIGATION = 'main-navigation';
export const MODAL = 'el-modal';
/**
 * Contenu de la modale: Le contenu est disponible uniquement lorsque la modale est ouverte via une directive "v-if".
 */
export const MODAL_CONTENT = 'el-modal-content';
export const POPOVER_CONTAINER = 'popover-container';
export const TAB_ITEM = 'el-tab-item';
/** stepper nav au-dessus des formulaires */
export const STEPPER_NAV = 'el-stepper-nav';
export const STEPPER_NAV_ITEM = 'stepper-nav-item';
export const ASYNC_LOADER = 'async-loader';
export const ASYNC_LOADER_STATUS_BOX = 'async-loader-status-box';
export const CALENDAR = 'el-calendar';
export const VALUE_SELECTOR_CONTENT = 'value-selector-content';
export const MULTILINE_VALUE = 'multiline-value';
export const LABEL_AND_VALUE_LABEL = 'LabelAndValue-label';
export const BOX_CARD = 'box-card';

/** Compostante ElTimePicker */
export const TIME_PICKER_MODAL_CONTENT = 'el-time-picker-modal-content';
export const TIME_PICKER_BUTTON = 'el-time-picker-button';
export const TIME_PICKER_SELECTED_TIME = 'el-time-picker-selected-time';
export const TIME_PICKER_LIST = 'el-time-picker-list';
export const TIME_PICKER_SAVE_BUTTON = 'el-time-picker-save-button';
export const ERROR_BOUNDARY = 'error-boundary';

export const DRIVER_NOTE_MODAL_CONTENT = 'driver-note-modal-content';
export const DRIVER_NOTE = 'driver-note';
export const ADDRESS_NOTE = 'address-note';

export const CONTEXTUAL_HELP_TOGGLE = 'contextual-help-toggle-button';
